// extracted by mini-css-extract-plugin
module.exports = {"container":"Spinner_container__1G_AO","spinner":"Spinner_spinner__1txf2","spin":"Spinner_spin__38-9o"};